/**
 * @voltxampere/ui — 6N137 high-speed optocoupler (Sprint 44-4, placeholder)
 *
 * PLACEHOLDER. High-speed digital optocoupler — input AlGaAs LED +
 * Schottky-clamped photodiode/IC composite. Veri hızı 10 Mbit/s.
 * Output digital (open-collector) Sprint 47+'da paired digital-gate
 * stamp ile aktif olur.
 *
 * Reference: Avago/Broadcom 6N137 — DIP-8. V_F = 1.4 V, t_pHL = 75 ns,
 * t_pLH = 75 ns. Logic-level isolation (RS-422, isolated UART, fiber
 * optic transceiver, ground-loop break).
 *
 * Engine zero-diff invariant honored — canonical `led` engine type
 * via schemaType (input side AlGaAs LED).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const opto6n137 = {
    id: "6n137",
    nameTr: "6N137 (Yüksek Hız Opto 10Mbit/s, DIP-8, placeholder)",
    nameEn: "6N137 (High-speed Opto 10Mbit/s, DIP-8, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "U",
    defaultValue: "6N137",
    schemaType: "led",
    defaultParams: { saturationCurrent: 1e-12, ideality: 2 },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=opto-6n137.js.map